import { ACT_NTF_CHANGE } from "../actions/ActionTypes";

const initialState = {
	notificationList:[]
};

export default function(state = initialState, action) {
	if (action.type === ACT_NTF_CHANGE) {
		return Object.assign({}, state, action.props);
	}
	return state;
}



// WEBPACK FOOTER //
// ./src/reducers/NotificationReducer.js